/* ============================================================
   NEXYMOR — THEME JS v1.0
   ============================================================ */
(function() {
  'use strict';

  /* ── GLOBAL NAMESPACE ── */
  window.NEXYMOR = {

    /* ── CART ── */
    async addToCart(variantId, btn) {
      if (!variantId) return;
      const original = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (!res.ok) throw new Error('Add to cart failed');
        await NEXYMOR.updateCartCount();
        if (window.NEXYMOR_SETTINGS && window.NEXYMOR_SETTINGS.cartDrawer) {
          NEXYMOR.openCart();
        } else {
          window.location.href = '/cart';
        }
      } catch (e) {
        console.error(e);
      } finally {
        if (btn) { btn.textContent = original; btn.disabled = false; }
      }
    },

    async updateQty(key, qty) {
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        if (!res.ok) throw new Error();
        const cart = await res.json();
        NEXYMOR.refreshCartDrawer(cart);
      } catch(e) { window.location.reload(); }
    },

    async updateCartCount() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        const el = document.getElementById('cartCount');
        if (el) el.textContent = cart.item_count;
        const drawerCount = document.getElementById('cartDrawerCount');
        if (drawerCount) drawerCount.textContent = '(' + cart.item_count + ')';
      } catch(e) {}
    },

    refreshCartDrawer(cart) {
      const count = document.getElementById('cartCount');
      if (count) count.textContent = cart.item_count;
      const drawerCount = document.getElementById('cartDrawerCount');
      if (drawerCount) drawerCount.textContent = '(' + cart.item_count + ')';
    },

    /* ── CART DRAWER ── */
    openCart() {
      const drawer = document.getElementById('cartDrawer');
      const overlay = document.getElementById('page-overlay');
      if (drawer) drawer.classList.add('open');
      if (overlay) overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    },

    closeCart() {
      const drawer = document.getElementById('cartDrawer');
      const overlay = document.getElementById('page-overlay');
      if (drawer) drawer.classList.remove('open');
      if (overlay) overlay.classList.remove('active');
      document.body.style.overflow = '';
    },

    /* ── SEARCH ── */
    openSearch() {
      const modal = document.getElementById('searchModal');
      if (modal) {
        modal.classList.add('open');
        document.body.style.overflow = 'hidden';
        setTimeout(() => { const inp = document.getElementById('searchInput'); if (inp) inp.focus(); }, 100);
      }
    },

    closeSearch() {
      const modal = document.getElementById('searchModal');
      if (modal) modal.classList.remove('open');
      document.body.style.overflow = '';
    },

    /* ── MOBILE NAV ── */
    openMobileNav() {
      const nav = document.getElementById('mobileNav');
      const overlay = document.getElementById('page-overlay');
      if (nav) nav.classList.add('open');
      if (overlay) overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    },

    closeMobileNav() {
      const nav = document.getElementById('mobileNav');
      const overlay = document.getElementById('page-overlay');
      if (nav) nav.classList.remove('open');
      if (overlay) overlay.classList.remove('active');
      document.body.style.overflow = '';
    },

    /* ── CLOSE ALL ── */
    closeAll() {
      NEXYMOR.closeCart();
      NEXYMOR.closeSearch();
      NEXYMOR.closeMobileNav();
    },

    /* ── FAQ ── */
    toggleFaq(item) {
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(el => el.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    },

    /* ── IMAGE SWITCHER ── */
    switchImage(url, thumb) {
      const main = document.getElementById('mainProductImg');
      if (main) main.src = url;
      document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
      if (thumb) thumb.classList.add('active');
    },

    /* ── HEADER SCROLL ── */
    initHeader() {
      const header = document.getElementById('siteHeader');
      if (!header) return;
      let lastY = 0;
      window.addEventListener('scroll', () => {
        const y = window.scrollY;
        if (y > 20) header.classList.add('scrolled');
        else header.classList.remove('scrolled');
        lastY = y;
      }, { passive: true });
    },

    /* ── SCROLL ANIMATIONS ── */
    initAnimations() {
      const els = document.querySelectorAll('.fade-up, .fade-in');
      if (!els.length) return;
      const obs = new IntersectionObserver((entries) => {
        entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); } });
      }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
      els.forEach(el => obs.observe(el));
    },

    /* ── CURSOR ── */
    initCursor() {
      const dot = document.getElementById('cursorDot');
      const ring = document.getElementById('cursorRing');
      if (!dot || !ring) return;
      if (window.matchMedia('(hover: none)').matches) return;
      let mx = 0, my = 0, rx = 0, ry = 0;
      document.addEventListener('mousemove', e => { mx = e.clientX; my = e.clientY; dot.style.left = mx + 'px'; dot.style.top = my + 'px'; }, { passive: true });
      function animRing() {
        rx += (mx - rx) * 0.12;
        ry += (my - ry) * 0.12;
        ring.style.left = rx + 'px';
        ring.style.top = ry + 'px';
        requestAnimationFrame(animRing);
      }
      animRing();
      document.addEventListener('mouseenter', () => { dot.style.opacity = '1'; ring.style.opacity = '1'; });
      document.addEventListener('mouseleave', () => { dot.style.opacity = '0'; ring.style.opacity = '0'; });
      const interactEls = document.querySelectorAll('a, button, [role="button"], .filter-btn, .blog-cat, .search-tag, .faq-q');
      interactEls.forEach(el => {
        el.addEventListener('mouseenter', () => { ring.style.width = '48px'; ring.style.height = '48px'; ring.style.borderColor = 'var(--green)'; });
        el.addEventListener('mouseleave', () => { ring.style.width = '30px'; ring.style.height = '30px'; ring.style.borderColor = 'rgba(124,58,237,.4)'; });
      });
    },

    /* ── KEYBOARD ── */
    initKeyboard() {
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape') NEXYMOR.closeAll();
        if ((e.ctrlKey || e.metaKey) && e.key === 'k') { e.preventDefault(); NEXYMOR.openSearch(); }
      });
    },

    /* ── PRODUCT FORM (cart drawer mode) ── */
    initProductForms() {
      const forms = document.querySelectorAll('#product-form');
      forms.forEach(form => {
        form.addEventListener('submit', async (e) => {
          if (window.NEXYMOR_SETTINGS && window.NEXYMOR_SETTINGS.cartDrawer) {
            e.preventDefault();
            const variantInput = form.querySelector('[name="id"]');
            if (!variantInput) return;
            const submitBtn = form.querySelector('[type="submit"]');
            const originalText = submitBtn ? submitBtn.textContent : '';
            if (submitBtn) { submitBtn.textContent = 'Adding...'; submitBtn.disabled = true; }
            try {
              const res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ id: parseInt(variantInput.value), quantity: 1 })
              });
              if (!res.ok) throw new Error();
              await NEXYMOR.updateCartCount();
              NEXYMOR.openCart();
            } catch(err) { form.submit(); }
            finally { if (submitBtn) { submitBtn.textContent = originalText; submitBtn.disabled = false; } }
          }
        });
      });
    },

    /* ── FILTER BUTTONS ── */
    initFilters() {
      const filterBtns = document.querySelectorAll('[data-filter]');
      if (!filterBtns.length) return;
      filterBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          filterBtns.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          const filter = btn.dataset.filter;
          document.querySelectorAll('.product-card[data-category]').forEach(card => {
            if (filter === 'all' || card.dataset.category.includes(filter)) {
              card.style.display = '';
            } else {
              card.style.display = 'none';
            }
          });
        });
      });
    },

    /* ── INIT ── */
    init() {
      NEXYMOR.initHeader();
      NEXYMOR.initAnimations();
      NEXYMOR.initCursor();
      NEXYMOR.initKeyboard();
      NEXYMOR.initProductForms();
      NEXYMOR.initFilters();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', NEXYMOR.init.bind(NEXYMOR));
  } else {
    NEXYMOR.init();
  }

})();
